import "./DividendsTableComponent.scss";
import template from "./DividendsTableComponent.html";
import {IComponentOptions} from "angular";
import {DividendsModel} from "../../../../../dividends/models/DividendsModel";
import {Dividends, orderDividendsByDateDesc} from "../../../../../dividends/types/DividendsRecord";

export const DividendsTable = "tfDividendsTable";

export function dividendsTable(): IComponentOptions {
    return {
        template,
        bindings: {
            model: "<dividends"
        },
        controllerAs: "ctrl",
        controller: DividendsTableComponentController
    };
}

export class DividendsTableComponentController {

    /** @input */
    public set model(model: DividendsModel | null) {
        if (model == null) {
            this.dividends = [];
        } else {
            this.dividends = [...model.dividends].sort(orderDividendsByDateDesc());
        }
    }

    public dividends: Dividends;
}
